import { useReducedMotion } from '../../hooks/useReducedMotion';

/**
 * Continuous horizontal banner. The track is rendered twice so the loop is seamless; the CSS
 * animation moves it by exactly half its width. With reduced motion (or `static`) the items are
 * laid out as a wrapping row instead, so nothing moves and nothing is lost.
 */
export function MarqueeBanner({ items, speed = 'normal', pauseOnHover = true, respectReducedMotion = true, onNavy = false, label = 'Highlights', className = '' }: { items: string[]; speed?: 'slow' | 'normal' | 'fast'; pauseOnHover?: boolean; respectReducedMotion?: boolean; onNavy?: boolean; label?: string; className?: string }) {
  const reduced = useReducedMotion() && respectReducedMotion;
  const seconds = { slow: 55, normal: 38, fast: 24 }[speed] * Math.max(0.5, items.length / 8);
  const cls = ['marquee', reduced ? 'static' : '', pauseOnHover ? 'pause-hover' : '', onNavy ? 'on-navy' : '', className].filter(Boolean).join(' ');
  const track = (ariaHidden: boolean) => (
    <div className="track" aria-hidden={ariaHidden || undefined} style={{ ['--marquee-duration' as string]: `${seconds}s` }}>
      {items.map((it, i) => (
        <span key={`${it}-${i}`} className="item">{it}</span>
      ))}
    </div>
  );
  return (
    <div className={cls} role="region" aria-label={label}>
      {reduced ? (
        track(false)
      ) : (
        <div className="track" style={{ ['--marquee-duration' as string]: `${seconds}s` }}>
          {items.map((it, i) => <span key={`a-${it}-${i}`} className="item">{it}</span>)}
          {items.map((it, i) => <span key={`b-${it}-${i}`} className="item" aria-hidden="true">{it}</span>)}
        </div>
      )}
    </div>
  );
}
